import {
  name,
  version,
  publicPath,
} from 'front-hub-application-host-configuration-prod'

export default function ({ repository }) {
  return publicPath({ name, version, repository })
}
